export default "dist/images/block-accordion-basic.6639c67.png";